<template>
    <div>
        <container :active_path="path" :plate="'投资军团'">
            <div class="base-warp">
                <div class="head">
                    <el-form :model="form" label-width="80px" :inline="true" size="mini">
                        <el-form-item label="问题内容">
                            <el-input v-model="form.keyword" clearable></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="confirm">搜索</el-button>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="danger" v-if="showquestion" @click="setshowquestion(false)">隐藏问答</el-button>
                            <el-button type="success" v-else @click="setshowquestion(true)">展示问答</el-button>
                        </el-form-item>
                    </el-form>
                </div>
                <div class="table-box">
                    <el-collapse accordion>
                        <el-collapse-item v-for="(item, index) in tabledata"
                            :key="index">
                            <template slot="title">
                                <p class="base-title">
                                    <el-row>
                                        <el-col :span="14" :offset="0">
                                            <span class="title-text title">{{item.title?item.title:item.content}}</span>
                                        </el-col>
                                        <el-col :span="10" :offset="0">
                                            <span class="title-text">{{item.addtime}}</span>
                                            <span class="title-text">{{item.click}}人阅读</span>
                                            <span class="title-text">{{item.answer_length?item.answer_length:0}}人回答</span>
                                            <span class="title-text text-warning" v-if="item.status==0">待审核</span>
                                        </el-col>
                                    </el-row>
                                </p>
                            </template>

                            <div class="item-box">
                                <div class="lable">
                                    <el-avatar class="avatarsss" icon="el-icon-user-solid" size="large" shape="circle" :src="item.user.ltpic" fit="fill"></el-avatar>
                                    <div class="name">{{item.user.name}}</div>
                                </div>
                                <div class="info">
                                    <div class="intro-box">
                                        <div class="title">{{item.title}}</div>
                                        <div class="intro">{{item.content}}</div>
                                        <div class="foot">
                                            <el-row>
                                                <el-col class="left-item" :span="12" :offset="0">
                                                    <span class="text">添加时间：{{item.addtime}}</span>
                                                    <span class="text">阅读量：{{item.click}}</span>
                                                    <span class="text">审核状态：{{item.status}}</span>
                                                </el-col>
                                                <el-col class="right-item" :span="12" :offset="0">
                                                        <span class="text text-success" v-if="item.status=='02'">已上架</span>
                                                        <span class="text text-danger" v-else>未上架</span>
                                                        <el-button type="warning" size="mini" v-if="item.status=='02'" @click="questionputaway(item, '03')" plain>下架</el-button>
                                                        <el-button type="primary" size="mini" v-else @click="questionputaway(item, '02')" plain>上架</el-button>
                                                        <el-button type="danger" size="mini" @click="questiondel(item)">删除</el-button>
                                                </el-col>
                                            </el-row>
                                        </div>
                                    </div>
                                    <div v-if="item.answer">
                                        <div class="item-box answer-box" v-for="(answer, dex) in item.answer" :key="dex">
                                            <div class="lable">
                                                <el-avatar class="avatarsss" icon="el-icon-user-solid" :size="34" shape="circle" :src="answer.user.ltpic" fit="fill"></el-avatar>
                                                <div class="name">{{answer.user.name}}</div>
                                            </div>
                                            <div class="info">
                                                <div class="intro-box">
                                                    <div class="title">{{answer.title}}</div>
                                                    <div class="intro">{{answer.content}}</div>
                                                    <div class="foot">
                                                        <el-row>
                                                            <el-col class="left-item" :span="12" :offset="0">
                                                                <span class="text">添加时间：{{answer.addtime}}</span>
                                                                <span class="text">审核状态：{{answer.status}}</span>
                                                            </el-col>
                                                            <el-col class="right-item" :span="12" :offset="0">
                                                                    <span class="text text-success" v-if="answer.status=='02'">已上架</span>
                                                                    <span class="text text-danger" v-else>未上架</span>
                                                                    <el-button type="warning" v-if="answer.status=='02'" size="mini" @click="answerputaway(answer, '03')" plain>下架</el-button>
                                                                    <el-button type="primary" v-else size="mini" @click="answerputaway(answer, '02')" plain>上架</el-button>
                                                                    <el-button type="danger" size="mini" @click="answerdel(answer)">删除</el-button>
                                                            </el-col>
                                                        </el-row>
                                                    </div>
                                                </div>

                                                <div class="item-box dis-box">
                                                    <div class="list" v-for="(discu, ind) in answer.discuss" :key="ind">
                                                        <div class="lable">
                                                            <div class="name">{{discu.user.name}}</div>
                                                        </div>
                                                        <div class="info">
                                                            <div class="intro-box">
                                                                <div class="intro">{{discu.content}}</div>
                                                                <div class="foot">
                                                                    <el-row>
                                                                        <el-col class="left-item" :span="12" :offset="0">
                                                                            <span class="text">审核状态：{{discu.status}}</span>
                                                                        </el-col>
                                                                        <el-col class="right-item" :span="12" :offset="0">
                                                                                <span class="text text-success" v-if="discu.status=='02'">已上架</span>
                                                                                <span class="text text-danger" v-else>未上架</span>
                                                                                <el-button type="warning" v-if="discu.status=='02'" size="mini" @click="discuPutaway(answer, '03')" plain>下架</el-button>
                                                                                <el-button type="primary" v-else size="mini" @click="discuPutaway(discu, '02')" plain>上架</el-button>
                                                                                <el-button type="danger" size="mini" @click="discuDel(discu)">删除</el-button>
                                                                        </el-col>
                                                                    </el-row>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    

                                </div>
                            </div>

                        </el-collapse-item>
                    </el-collapse>
                </div>
                <el-pagination class="page-tion"
                    @current-change="currentChange"
                    layout="prev, pager, next"
                    :page-size="pagesize"
                    :total="total" background>
                </el-pagination>
            </div>
        </container>
    </div>
</template>

<script>
import Container from '../../../components/container.vue'
export default {
    components: {
        Container,
    },
    data() {
        return {
            path: '/invest/question',
            form: {
                keyword: '',
            },
            tabledata: [],
            pageNo: 1,
            pagesize: 8,
            total: 0,
            showquestion: false,
        }
    },
    mounted () {
        this.getTabledata();
        this.getQuestionModelPutaway();
    },
    methods: {
        setshowquestion(putaway) {
            var params = {
                putaway
            }
            this.$api.setQuestionModelPutaway(params).then(
                data=>{
                    this.$message.success(data);
                    this.showquestion = putaway;
                }
            )
        },
        getQuestionModelPutaway() {
            this.$api.getQuestionModelPutaway('').then(
                data=>{
                    if (!data){
                        this.showquestion = false; 
                        return;
                    } 
                    this.showquestion = data.show;
                }
            )
        },
        discuDel(item) {
            this.$confirm('是否确定是否确定删除评论').then(
                confirm=>{
                    var params = {
                        id: item._id['$oid'],
                    }
                    this.$api.delDiscuss(params).then(
                        data=>{
                            this.$message.success(data);
                            this.getTabledata();
                        }
                    )
                },
                cancel=>{}
            )
        },
        discuPutaway(item, status) {
            var params = {
                id: item._id['$oid'],
                putaway: status,
            }
            this.$api.discussPutaway(params).then(
                data=>{
                    this.$message.success(data);
                    this.getTabledata();
                }
            )
        },
        questionputaway(item, status) {
            var params = {
                id: item._id['$oid'],
                status,
            }
            this.$api.questionPutaway(params).then(
                data=>{
                    this.$message.success(data);
                    this.getTabledata();
                }
            )
        },
        questiondel(item) {
            this.$confirm('是否确定删除问题').then(
                confirm=>{
                    var params = {
                        id: item._id['$oid'],
                    }
                    this.$api.delQuestion(params).then(
                        data=>{
                            this.$message.success(data);
                            this.getTabledata();
                        }
                    )
                },
                cancel=>{}
            )
        },
        answerputaway(item, status) {
            var params = {
                id: item._id['$oid'],
                status,
            }
            this.$api.answerPutaway(params).then(
                data=>{
                    this.$message.success(data);
                    this.getTabledata();
                }
            )
        },
        answerdel(item) {
            this.$confirm('是否确定删除回答').then(
                confirm=>{
                    var params = {
                        id: item._id['$oid'],
                    }
                    this.$api.delAnswer(params).then(
                        data=>{
                            this.$message.success(data);
                            this.getTabledata();
                        }
                    )
                },
                cancel=>{}
            )
        },
        getTabledata() {
            var params = {
                pageNo: this.pageNo,
                pagesize: this.pagesize,
            }
            this.$api.getquestionlist(params).then(
                data=>{
                    let {list, total} = data;
                    this.tabledata = list;
                    this.total = total;
                }
            )
        },
        confirm() {
            this.pageNo = 1;
            this.getTabledata();
        },
        currentChange(page) {
            this.pageNo = page;
            this.getTabledata();
        },
    },
}
</script>

<style lang="scss" scoped>
.base-title{
    width: 100%;
    .title{
        display: inline-block;
        width: 500px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
}
.title-text{
    margin-right: 20px;
    
}
.dis-box{
    border-top: 1px solid #f7f7f7;
    .list{
        border-bottom: 1px solid #f7f7f7;
        .lable{
            padding-top: 10px;
        }
    }
}
.item-box.answer-box{
    background: #ebeef5;
    .lable{
        top: 0;
        .avatarsss{
            margin-left: 5px;
        }
        .name{
            text-align: center;
        }
    }
    .info{
        .intro-box{
            background: #ebeef5;
        }
    }
}
.item-box{
    position: relative;
    .lable{
        position: absolute;
        top: 10px;
        left: 0;
        width: 40px;
        .name{
            font-weight: 600;
            color: #666;
        }
    }
    .info{
        padding-left: 50px;
        box-sizing: border-box;
        .intro-box{
            background: #e4e7ed;
            padding: 10px;
            border-bottom: 1px solid #eee;
            .title{
                font-weight: bold;
                font-size: 15px;
            }
            .intro{
                color: #555;
            }
            .foot{
                margin-top: 10px;
                color: #666;
                line-height: 28px;
                width: 100%;
                .left-item{
                    text-align: left;
                    .text{
                        margin-right: 10px;
                    }
                }
                .right-item{
                    text-align: right;
                    .text{
                        margin-right: 20px;
                    }
                }
            }
        }
    }
}
</style>